import React, { useState } from "react";
import { Typography, Box, Skeleton } from "@mui/material";
import { Avatar, getIcon } from "@dishopsaas/design-system";
import { getColors } from "../../../utils";
import RestaurantHoursModal from "../../Modal/RestaurantHoursModal";

type ShopHeaderContentProps = {
  logoUrl: string;
  name: string;
  text?: string;
  isOpen?: boolean;
  isTablet?: boolean;
  showTextsLg?: boolean;
  styles: any;
  withContainer?: boolean;
  address?: string;
  addressShop?: string;
  orderType?: string;
  googleApiKey: string,
  secondaryColor: string,
  theme: string
  orderTypes: any,
  openHours: any,
  shopName?: string;
  isQrCode?: boolean
};

export const ShopHeaderContent: React.FC<ShopHeaderContentProps> = ({
  logoUrl,
  name,
  text,
  showTextsLg = false,
  styles,
  withContainer = false,
  address,
  addressShop,
  googleApiKey,
  secondaryColor,
  theme,
  orderTypes,
  openHours,
  shopName,
  isQrCode
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleModal = React.useCallback((value: boolean): void => {
    setOpen(value);
  }, []);
  const words = name?.split(" ").slice(0, 2) || [];
  const isSingleLine = words.length === 1;
  const isLoadingName = !name;
  const content = (
    <>
      {logoUrl && <Avatar src={logoUrl} size="md" shape="rounded" />}
      <div
        style={{
          ...styles.textBlock,
          justifyContent: "space-between"
        }}
      >
        {isLoadingName ? (
          <Skeleton
            variant="text"
            width={158}
            height={28}
            sx={{ borderRadius: "6px" }}
          />
        ) : (
          <Typography
            variant={logoUrl ? "h5" : 'subtitle1'}
            sx={{
              color: getColors().text,
              ...styles.shopName
            }}
          >
            {name}
          </Typography>
        )}

        {showTextsLg && !isQrCode && (
          <Box
            sx={logoUrl ? styles.tagBlock : styles.mobileTextBlock}
            onClick={() => handleModal(true)}
          >
            {getIcon('clock', { size: logoUrl ? 16 : 12 })}
            <Typography variant={logoUrl ? 'body1' : 'caption'} sx={{ textDecoration: 'underline' }}>
              {text}
            </Typography>
          </Box>
        )}
      </div>

      <RestaurantHoursModal
        open={open}
        onClose={() => handleModal(false)}
        address={address}
        addressShop={addressShop}
        statusLabel={text}
        openHours={openHours}
        googleApiKey={googleApiKey}
        secondaryColor={secondaryColor}
        theme={theme}
        orderTypes={orderTypes}
        shopName={shopName}
      />
    </>
  );

  if (withContainer) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexGrow: 1,
          justifyContent: isSingleLine ? "center" : "flex-start",
          minWidth: 0,
          overflow: "hidden"
        }}
      >
        {content}
      </div>
    );
  }

  return <>{content}</>;
};

export default ShopHeaderContent;
